<template>
    <div :class="this.$route.name == 'send-shipment' ? 'bg-white' : ''">
        <!-- <div
            class="message"
            v-show="showMSG"
            v-if="
                this.$route.name == 'send-shipment' ||
                this.$route.name == 'homepage'
            "
        >
            <i class="mdi mdi-close" @click="showMSG = false"></i>
            <p>
                {{
                    $t(
                        "Due to COVID-19 all transite time will take longer than usual"
                    )
                }}
            </p>
        </div> -->
        <!-- <shipment-nav
            v-if="
                this.$route.name == 'send-shipment' ||
                this.$route.name == 'invoice'
            "
        ></shipment-nav> -->
        <app-navbar></app-navbar>
        <div class="container" style="min-height: 800px">
            <div>
                <router-view></router-view>
            </div>
        </div>
        <app-footer></app-footer>
    </div>
</template>

<script>
import Navbar from "@/components/Nav/Navbar.vue";
// import shipmentNav from "@/components/Nav/shipmentNav.vue";
import Footer from "@/components/Footer/Footer.vue";

export default {
    components: {
        "app-navbar": Navbar,
        "app-footer": Footer,
        // "shipment-nav": shipmentNav,
    },
    data() {
        return {
            showMSG: true,
        };
    },
};
</script>

<style lang="scss">
#main-card {
    background: white !important;
    border-radius: 10px;
    min-width: 40%;
    min-height: 300px;
    width: 100%;
    height: 100%;
    margin-bottom: 40px;

    #step-navigation-area {
        text-align: center;
        padding-bottom: 20px;

        button {
            display: inline-block;
            width: 100px;
        }
    }

    #form-area {
        min-height: 300px;
    }
}

.message {
    display: flex;
    align-items: center;
    padding: 10px;
    border-radius: 0 !important;
    background: #f2f2f2;
    position: relative;
    margin-bottom: 0 !important;
    font-size: 14px !important;

    .mdi {
        border-radius: 50%;
        margin: 0 15px;
        padding: 0 5px;
        transition: 0.3s;

        &:hover {
            background: #ddd;
            cursor: pointer;
        }
    }
}
</style>
